import { Txt } from "@stenajs-webui/core";

import { formatSailingLinkText } from "../../../common-ui/sailing-info/utils/formatSailingLinkText";
import type { DetailedIntermodalBooking } from "../../../common/graphql/fragments/gql/IntermodalBooking";
import { useLocalDateFormat } from "../../../common/hooks/useLocalDateFormat";

interface IntermodalJourneyTxtProps {
  booking: DetailedIntermodalBooking;
}

export const IntermodalJourneyTxt = ({
  booking,
}: IntermodalJourneyTxtProps) => {
  const dateFormat = useLocalDateFormat();

  return (
    <Txt>
      {formatSailingLinkText(
        booking.journey,
        booking.journey.route.id,
        dateFormat,
      )}
    </Txt>
  );
};
